var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedJobId
    ? _c("div", { staticClass: "boss-pickup-wrap" }, [
        _c("div", { staticClass: "boss-pickup-form" }, [
          _c("div", { staticClass: "boss-pickup-headline" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "boss-pulldown-container boss-published margin-bottom-0",
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "boss-pulldown-menu",
                    attrs: { for: "boss-published-item" },
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedJobId,
                            expression: "selectedJobId",
                          },
                        ],
                        staticClass: "boss-pulldown-menu-item",
                        attrs: {
                          id: "boss-published-item",
                          "data-test": "job-pulldown",
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedJobId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.onChangeJob,
                          ],
                        },
                      },
                      _vm._l(
                        _vm.publishedContract.jobs.filter(function (job) {
                          return job.isPublished
                        }),
                        function (job, key) {
                          return _c(
                            "option",
                            {
                              key: key,
                              attrs: { "data-test": "job-" + key },
                              domProps: { value: job.id },
                            },
                            [
                              _vm._v(
                                "\n              求人ID: " +
                                  _vm._s(job.id) +
                                  " " +
                                  _vm._s(job.managementName) +
                                  "\n            "
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-form-container" }, [
            _c(
              "div",
              {
                staticClass:
                  "boss-layout boss-layout-vertical boss-layout-fill",
              },
              [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "boss-batch-container clearfix padding-top-0",
                    },
                    [
                      _c("scout-members-bulk-register", {
                        attrs: {
                          "job-id": _vm.selectedJobId,
                          "contract-id": _vm.publishedContract.id,
                          "member-objects": _vm.checkedMemberObjects,
                        },
                        on: {
                          fetch: function ($event) {
                            return _vm.fetchRecommended(
                              _vm.publishedContract.id,
                              _vm.selectedJobId
                            )
                          },
                          clearCheckedMembers: _vm.clearCheckedMembers,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "boss-resumecard-list" },
                    [
                      _vm._l(
                        _vm.infinityMemberObjects,
                        function (memberObject, i) {
                          return [
                            !memberObject.member.isScoutExcluded
                              ? _c("scout-resume-card", {
                                  key: i,
                                  attrs: {
                                    "member-object": memberObject,
                                    checked: _vm.checkedMemberIds,
                                    "contract-id": _vm.publishedContract.id,
                                    "job-id": _vm.selectedJobId,
                                    "shows-scout-button": _vm.isSendScout,
                                  },
                                  on: {
                                    checked: _vm.checked,
                                    change: _vm.changed,
                                    spliceCheckedMember:
                                      _vm.spliceCheckedMember,
                                  },
                                })
                              : _vm._e(),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("infinity-scroll", {
                  attrs: {
                    objects: _vm.memberObjects,
                    "infinity-objects": _vm.infinityMemberObjects,
                    "display-count": _vm.displayCount,
                    "no-results-label": _vm.noResultsLabel,
                  },
                  on: {
                    "update:infinityObjects": function ($event) {
                      _vm.infinityMemberObjects = $event
                    },
                    "update:infinity-objects": function ($event) {
                      _vm.infinityMemberObjects = $event
                    },
                  },
                }),
                _vm._v(" "),
                _c("scout-recommended-footer", {
                  attrs: { "show-recommended-less": _vm.showRecommendedLess },
                }),
                _vm._v(" "),
                _c("selected-counter", {
                  attrs: { "checked-count": _vm.checkedMemberIds.length },
                }),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "boss-pickup-title" }, [
      _c("span", { staticClass: "boss-icon boss-icon-pickup" }),
      _vm._v(" "),
      _c("span", [_vm._v("本日のおすすめ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }